import React from 'react'
import VisitInfo from './visitInfo'
import CustomReviews from './myReview'

function AllVisit() {
  return (
    <div className='p-6'>
    <div className=' bg-white rounded-xl'>
        <VisitInfo title={'بازدیدهای کشاورز'}/>
        <CustomReviews showHeader={true}  header={true}/>
    </div>
        
    </div>
  )
}

export default AllVisit